import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { SortDirections } from '@shared/components/sortable-section/models/sortable-section.model';

@Component({
  selector: 'app-sort-product-modal',
  templateUrl: './sort-product-modal.component.html',
  styleUrls: ['./sort-product-modal.component.scss'],
})
export class SortProductModalComponent {
  @Input() sortDirection: SortDirections;
  @Input() filterSelection: boolean;
  filterSortCount: number;
  readonly SortDirections = SortDirections;

  constructor(
    readonly platformService: PlatformService,
    private modalController: ModalController,
  ) {}

  getSortFilterCount(): number {
    let count = 0;

    if (this.filterSelection) {
      count++;
    }

    if (this.sortDirection !== null) {
      count++;
    }

    return count;
  }

  setFilter() {
    this.filterSelection = !this.filterSelection;
  }

  itemSelected(sortDirection: SortDirections) {
    this.sortDirection =
      this.sortDirection === sortDirection ? null : sortDirection;
  }

  async closeModal() {
    await this.modalController.dismiss();
  }

  async applyAndClose() {
    await this.modalController.dismiss({
      filterSelection: this.filterSelection,
      sortOrClear: true,
      sortDirection: this.sortDirection,
      sortFilterCount: this.getSortFilterCount(),
    });
  }

  async clearAll() {
    this.filterSelection = null;
    this.sortDirection = null;
    this.filterSortCount = 0;
  }
}
